//import actions from 'store/actions';
import { List, Map } from 'immutable';

import step from './stepActions';
import filter from './filterActions';
import orderBy from './orderByActions';
import corporate from './corporateActions';
import loyalty from './loyaltyActions';
import reservation from './reservation/reservationActions';
import reservationRequest from './reservation/reservationRequestActions';
import params from '@synergycms_core/store/customer/paramsActions';
import moment from 'moment';

import currency from '@synergycms_core/store/customer/currencyAction';
import { apiGetter, momentLangCodes, langCodeCorrector } from '@synergycms_core/utils/api';
import storage from '@synergycms_core/utils/storage';
import { toLower, forEachObjIndexed } from 'ramda';
import { set } from '@synergycms_core/utils';
import actions from './../actions';
import { cleanHotelPreferences } from '../../utils';
import api from '@synergycms_core/utils/api';

let hotelCallbacks = {};

export default {
  ...currency,
  STEP: step,
  FILTERS: filter,
  CORPORATE: corporate,
  ORDER_BY: orderBy,
  RESERVATION_REQUEST: reservationRequest,
  RESERVATION: reservation,
  PARAMS: params,
  LOYALTY: loyalty,
  HEADER: {
    SHOW: (key, show) => {
      return { key, show };
    }
  },
  CURRENCY_COUNTRY: {
    GET_ASYNC: () => {
      return (dispatch, getState) => {

        const currencyCountryStorage = storage.getLocal('currency_country_v2');
        if (getState().getIn(['customer', 'currencies']) && getState().getIn(['customer', 'country'])) {
          return Promise.resolve();
        }

        return currencyCountryStorage
          ? Promise.resolve(currencyCountryStorage)
          : api.get('cms/check_ip_user', {}).then(response => {
            const currencyCountry = !(response.success === false)
              ? response
              : { CountryCode: 'ES', CurrencyCode: 'EUR', ClientIP: 'unknownIP' };
            if (currencyCountry.CountryCode.toString().length > 0 && currencyCountry.ClientIP !== 'unknownIP') {
              storage.setLocal('currency_country_v2', currencyCountry);
            }
            return currencyCountry;
          }).catch(() => {
            return { CountryCode: 'ES', CurrencyCode: 'EUR', ClientIP: 'unknownIP' };
          });
      };
    }
  },
  LANG_INFO: {
    GET: langInfo => {
      moment.locale(toLower(momentLangCodes(langCodeCorrector(langInfo.code))));
      langInfo.code = langCodeCorrector(langInfo.code);
      return langInfo;
    }
  },
  WEB_TYPE: {
    GET: webType => {
      return webType;
    }
  },
  RATE_SELECTED: {
    SET: rateSelected => {
      return (dispatch, getState) => {
        return rateSelected;
      };
    }
  },
  GOOGLE_API_KEY: {
    GET: googleApiKey => {
      return googleApiKey;
    }
  },
  CURRENT_HOTELS: {
    SET: hotelsIds => {
      return (dispatch, getState) => {
        return hotelsIds ? new List(hotelsIds) : getState().getIn(['customer', 'params', 'params', 'hotels']);
      };
    }
  },

  CURRENT_HOTEL: {
    REGISTER_CALLBACK: (code, callback) => {
      hotelCallbacks = set(code, callback, hotelCallbacks);
      //console.log(hotelCallbacks);
    },
    ON_CHANGE: () => {
      return (dispatch) => {

        hotelCallbacks = forEachObjIndexed(callback => {
          dispatch(callback());
        }, hotelCallbacks);
      };
    },

    SET_ID: hotelId => {
      return (dispatch, getState) => {
        const store = getState();
        const currentHotelId = hotelId
          ? hotelId.toString()
          : store.getIn(['customer', 'params', 'params', 'hotelId'], '').toString() || null;
        return currentHotelId;
      };
    },
    SET: hotelId => {
      return (dispatch, getState) => {
        const currentHotelActions = actions.customer.currentHotel;
        dispatch(currentHotelActions.setId(hotelId));
        dispatch(currentHotelActions.onChange());
      };
    },
    CLEAR: () => {
      return (dispatch, getState) => {
        const currentHotelActions = actions.customer.currentHotel;
        dispatch(currentHotelActions.clearId());
        dispatch(currentHotelActions.onChange());
      };
    },
    CLEAR_ID: () => {
      return null;
    }
  },
  TRANSACTION_ID: {
    SET: transactionId => {
      return (dispatch, getState) => {
        return transactionId;
      };
    }
  },
  ROOM_PREFERENCES: {
    INITIALIZE: () => {
      return (dispatch, getState) => {
        const store = getState();
        const hotelId = store.getIn(['customer', 'current_hotel']);
        const preferences = cleanHotelPreferences(store.getIn(['hotels', hotelId, 'preferences'], List()));

        return preferences.reduce((preferences, preference) => {
          return preferences.push(
            Map({
              preference_id: preference.get('id'),
              option_id: preference.getIn(['options', 0, 'id'])
            })
          );
        }, List());
      };
    }
  },
  CURRENT_PAYMENT_SELECTED: {
    SET: paymentCode => {
      return (dispatch, getState) => {
        return paymentCode;
      };
    }
  },
  CARD_MASK: {
    GET_ASYNC: (reservation, hotelID) => {
      return (dispatch, getState) => {
        const apiPci = apiGetter('pci');
        const trackingID = reservation.get('tracking_id');
        const hotelCode = reservation.get('hotel_code');
        const pinCode = reservation.get('pin_code');
        const tokenID = reservation.getIn(['payment', 'token'], false) || reservation.getIn(['token'], false);
        const fromTMS = getState().getIn(['customer', 'params', 'url_params', 'from_tms'], false) === 'true';
        const extraHeaders = [{ Authorization: 'Basic ' + btoa(trackingID + ':' + pinCode) }];

        if (tokenID) {
          return apiPci.query('GET', 'CardsApp/showMask', {
            hotel_code: hotelCode,
            token_id: tokenID,
            from_tms: (fromTMS ? '1' : '0'),
            test: process.env.NODE_ENV !== 'production'
          }, null, extraHeaders).then(response => {
            return !(response.success === false)
              ? response.card_mask
              : { error: 'Api Error' };
          });
        } else {
          return 'NO_TOKEN';
        }
      };
    }
  },
  HAS_CVV: {
    GET_ASYNC: (reservation, hotelID) => {
      return (dispatch, getState) => {
        const apiPci = apiGetter('pci');
        const trackingID = reservation.get('tracking_id');
        const hotelCode = reservation.get('hotel_code');
        const pinCode = reservation.get('pin_code');
        const tokenID = reservation.getIn(['payment', 'token'], false) || reservation.getIn(['token'], false);
        const fromTMS = getState().getIn(['customer', 'params', 'url_params', 'from_tms'], false) === 'true';
        const extraHeaders = [{ Authorization: 'Basic ' + btoa(trackingID + ':' + pinCode) }];
        if (!tokenID) {
          return false;
        }
        return apiPci.query('GET', 'CardsApp/hasCVVAvailable', {
          hotel_code: hotelCode,
          token_id: tokenID,
          from_tms: (fromTMS ? '1' : '0'),
          test: process.env.NODE_ENV !== 'production'
        }, null, extraHeaders).then(response => {
          return !(response.success === false)
            ? response.has_cvv
            : { error: 'Api Error' };
        });
      };
    }
  },
  STRIPE_TOKEN: {
    GET_ASYNC: (currency, lang, price, hotelCode, trackingId, redirectUrl, force = false) => {
      return (dispatch, getState) => {

        const store = getState(),
          hotelId = store.getIn(['customer', 'current_hotel']);
        let hotelInfo = store.getIn(['hotels', hotelId]);
        let tpv = !(hotelInfo.getIn(['tpv_only_gift_voucher'], false)) ? hotelInfo.getIn(['tpv', 'name'], false) : false;
        if ((!store.getIn(['customer', 'stripe_token'], false) || force) && tpv === 'Stripe') {
          const data = {
            currency: currency,
            lang: lang,
            amount: price,
            id: hotelCode + '-' + trackingId,
            location: redirectUrl,
            payform_code: 'htl'
          };
          return api
            .post('/stripe_payments', data, hotelId)
            .then(response => {
              return response.client_secret ? response.client_secret : false;
            });
        }
      };
    }
  },
  IP_COUNTRY: {
    GET_ASYNC: () => {
      return (dispatch, getState) => {
        const store = getState(),
          hotelId = store.getIn(['customer', 'current_hotel']);
        let hotelInfo = store.getIn(['hotels', hotelId]);
        let travelClubEnabled = hotelInfo.getIn(['travelclub'], false);
        if (travelClubEnabled) {
          return store.getIn(['customer', 'country', 'code'], 'ES');
        } else {
          return false;
        }
      };
    }
  }
};
